/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconResizeHorizontalLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="-1 0 19.999902 18">
    <><defs id="defs2" />
<g id="Free-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" transform="rotate(90,9.4999753,9.4999753)">
    <g transform="translate(-1118,-452)" id="Group" stroke="#000000" strokeWidth={2}>
        <g transform="translate(1115,450)" id="Shape">
            <line x1="4" y1="12" x2="20" y2="12" id="line1" />
            <polygon points="16.5,8 12,3 7.5,8 " id="polygon1" />
            <polygon points="16.5,16 7.5,16 12,21 " id="polygon2" />
        </g>
    </g>
</g></>
  </Icon>
);
};

IconResizeHorizontalLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB3aWR0aD0iNzk5Ljk5NjA5IiBoZWlnaHQ9IjcyMCIgdmlld0JveD0iLTEgMCAxOS45OTk5MDIgMTgiIHZlcnNpb249IjEuMSIgaWQ9InN2ZzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnMgaWQ9ImRlZnMyIi8+CiAgPGcgaWQ9IkZyZWUtSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgdHJhbnNmb3JtPSJyb3RhdGUoOTAsOS40OTk5NzUzLDkuNDk5OTc1MykiPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMTgsLTQ1MikiIGlkPSJHcm91cCIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTE1LDQ1MCkiIGlkPSJTaGFwZSI+CiAgICAgICAgPGxpbmUgeDE9IjQiIHkxPSIxMiIgeDI9IjIwIiB5Mj0iMTIiIGlkPSJsaW5lMSIvPgogICAgICAgIDxwb2x5Z29uIHBvaW50cz0iMTYuNSw4IDEyLDMgNy41LDggIiBpZD0icG9seWdvbjEiLz4KICAgICAgICA8cG9seWdvbiBwb2ludHM9IjE2LjUsMTYgNy41LDE2IDEyLDIxICIgaWQ9InBvbHlnb24yIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPg==";
IconResizeHorizontalLineComponent.Content = `<svg width="799.99609" height="720" viewBox="-1 0 19.999902 18" version="1.1" id="svg2" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
  <defs id="defs2"/>
  <g id="Free-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" transform="rotate(90,9.4999753,9.4999753)">
    <g transform="translate(-1118,-452)" id="Group" stroke="#000000" stroke-width="2">
      <g transform="translate(1115,450)" id="Shape">
        <line x1="4" y1="12" x2="20" y2="12" id="line1"/>
        <polygon points="16.5,8 12,3 7.5,8 " id="polygon1"/>
        <polygon points="16.5,16 7.5,16 12,21 " id="polygon2"/>
      </g>
    </g>
  </g>
</svg>`;

const IconResizeHorizontalLine = styled(IconResizeHorizontalLineComponent)``;

export default IconResizeHorizontalLine;
